export enum AdminPageSize {
  Medium = 'medium',
  MediumLarge = 'mediumLarge',
  Large = 'large',
}
